<div class="deactivation-warning">
  <div class="deactivation-warning__header">
    <h2 id="deactivationWarningTitle" class="deactivation-warning__title">
      Are you sure you want to deactivate Source Schain?
    </h2>
    <div class="deactivation-warning__close">
      <span
        nz-icon
        nzType="close"
        nzTheme="outline"
        (click)="onCloseModal()"
      ></span>
    </div>
  </div>

  <div class="deactivation-warning__body">
    <p class="deactivation-warning__lead">Deactivation will:</p>
    <ul class="deactivation-warning__list">
      <li class="deactivation-warning__item">
        Disable Source Schain dashboard until the toggle is turned back on.
      </li>
      <li class="deactivation-warning__item">
        Automatically deactivate the Source Schain checkbox in any DSP endpoints
        where it is currently enabled.
      </li>
    </ul>

    <p class="deactivation-warning__notice">
      Your Source Schain files will be stored in the system, but you won’t be
      able to interact with them until the toggle is turned back on.
    </p>
  </div>

  <div class="deactivation-warning__footer">
    <button
      nz-button
      type="button"
      nzType="default"
      class="deactivation-warning__btn deactivation-warning__btn--secondary"
      (click)="onCloseModal()"
    >
      Go Back
    </button>
    <button
      nz-button
      type="button"
      nzType="primary"
      class="deactivation-warning__btn deactivation-warning__btn--primary"
      (click)="onConfirm()"
    >
      Confirm
    </button>
  </div>
</div>
